import React, { Component } from "react";
import PropTypes from "prop-types";
import { postSignup } from "../utils/hubspot";

class Flow extends Component {
	constructor(props) {
		super(props);
		
		// Initialize seen array based on number of children
		const seen = [];
		const childArray = Array.from(this.props.children);
		childArray.forEach((_child, index) => {
			seen[index] = false;
		});

		this.state = {
			activeStep: 0,
			inputs: {},
			seen,
		};

		this.onStepCompleteHandler = this.onStepCompleteHandler.bind(this);
		this.onStepPreviousHandler = this.onStepPreviousHandler.bind(this);
	}

	onStepCompleteHandler(inputs) {
		this.setState(
			(prevState) => ({
				inputs: {
					...prevState.inputs,
					...inputs,
				},
			}),
			() => {
				const inputs = { ...this.state.inputs };

				// Hubspot requires first and last name
				if (inputs.name) {
					const fullName = inputs.name.split(" ");

					if (fullName.length === 1) {
						inputs.firstname = fullName[0];
						inputs.lastname = "";
					} else {
						inputs.firstname = fullName.shift();
						inputs.lastname = fullName.join(" ");
					}

					delete inputs.name;
				}
				postSignup(inputs);
				this.moveStep();
			}
		);
	}

	onStepPreviousHandler(evt) {
		evt.preventDefault();
		this.moveStep(-1);
	}

	moveStep(val = 1) {
		if (this.props.processing) {
			return;
		}

		this.setState((prevState) => {
			const activeStep = prevState.activeStep + val;

			if (activeStep >= React.Children.count(this.props.children)) {
				this.props.onComplete(prevState.inputs);
				return null; // Don't update state, just trigger completion
			} else if (activeStep < 0) {
				return null; // Don't update state for invalid step
			}

			this.props.resetErrorMessage();

			const seen = prevState.seen.map((v, i) => v || i <= activeStep);

			return {
				activeStep,
				seen,
			};
		});
	}

	render() {
		const { title, errMsg } = this.props;
		const { activeStep } = this.state;
		const flowTitle = typeof title === "string" ? <h1>{title}</h1> : title;

		const children = React.Children.map(this.props.children, (child, i) =>
			React.cloneElement(child, {
				active: i === activeStep,
				seen: this.state.seen[i],
				processing: this.props.processing,
				onComplete: this.onStepCompleteHandler,
				onPrevious: this.onStepPreviousHandler,
				errMsg,
			})
		);

		return (
			<React.Fragment>
				{flowTitle && <div className="flow-title">{flowTitle}</div>}
				{children}
			</React.Fragment>
		);
	}
}

Flow.propTypes = {
	children: PropTypes.node.isRequired,
	onComplete: PropTypes.func.isRequired,
	title: PropTypes.node,
	processing: PropTypes.bool,
	errMsg: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	resetErrorMessage: PropTypes.func,
};

export default Flow;
